import classNames from 'classnames';
import React from 'react';
import styles from './EditedBySimpleText.module.scss';
import withInspector from 'fulogics-ui-web/dist/layout/inspector/hoc/withInspector';
import EditedBySimpleTextSchema from './EditedBySimpleTextSchema';
import { LogisticUnitSimpleTextData } from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';
import LogisticUnitSimpleText from 'fulogics-ui-web/dist/layout/components/logistic-unit-simple-text/LogisticUnitSimpleText';

const EditedBySimpleText = (props: EditedBySimpleTextProps) => {
    const displayObject = [];

    const count = props.displayCount ?? 2;

    if (!!props.data) {
        for (let i = 0; i < props.data.length; i++) {
            displayObject.push(
                <LogisticUnitSimpleText
                    key={i}
                    className={classNames(styles.box)}
                    data={props.data[i]?.organization}
                    hideShortName={false}
                    hideContactButton
                    hideLabel
                    hideName
                />
            );
        }
        if (props?.data?.length > count) {
            displayObject.push(
                <label key={props.data?.length + 2} className={classNames(styles.box)}>
                    (+{props.data?.length - count})
                </label>
            );
        }
    }

    return <div className={classNames(styles.container, props.className)}>{displayObject}</div>;
};

export type EditedBySimpleTextProps = {
    data?: EditedBySimpleTextData;
} & EditedBySimpleTextDisplayOptions;

export default withInspector<EditedBySimpleTextProps>(
    EditedBySimpleText,
    EditedBySimpleTextSchema,
    undefined,
    undefined,
    { displayCount: 2 }
);

export class EditedBySimpleTextDisplayOptions {
    className?: string;
    displayCount?: number;
}

export type EditedBySimpleTextData = {
    organization?: LogisticUnitSimpleTextData;
}[];

export const EditedBySimpleTextDataKeys = [];
